"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCaseToTitleCase = exports.capitalize = void 0;
function capitalize(value) {
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}
exports.capitalize = capitalize;
function camelCaseToTitleCase(value) {
    const regexp = /[A-Z](?=[A-Z][a-z])|[^A-Z](?=[A-Z])|[A-Za-z](?=[^A-Za-z])/g;
    return capitalize(value.replace(regexp, '$& '));
}
exports.camelCaseToTitleCase = camelCaseToTitleCase;
//# sourceMappingURL=string-case.js.map